import { render, staticRenderFns } from "./WICPoliciesMOM.vue?vue&type=template&id=7841fb02&"
import script from "./WICPoliciesMOM.vue?vue&type=script&lang=js&"
export * from "./WICPoliciesMOM.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports